<style lang="less">
    .hide-cursor {
        cursor: none !important;
    }
    .grab-cursor {
        cursor: -webkit-grab !important;
        cursor: grab !important;
    }
    .grabing-cursor {
        cursor: -webkit-grabbing !important;
        cursor: grabbing !important;
    }
    .slider-container {
        z-index: -1;
        display: none;
        position: fixed;
        .slider-present {
            background-color: black;
            z-index: 0;

            position: relative;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            // display: flex;
            // align-items: center;
            // justify-content: center;
            // position: fixed;
            // top:0;
            // bottom: 0;
            // right: 0;
            // left: 0;
            // >canvas{
            //     position: absolute;
            //     top: 50%;
            //     left: 50%;
            //     transform: translate(-50%, -50%);
            // }
            #sliderCanvas,
            #sliderAnimationCanvas {
                position: fixed;
                z-index: -1;
            }
            .echart-list {
                position: fixed;
                width: 100%;
                height: 100%;
                z-index: 2;
                pointer-events: none;
                overflow: hidden;
            }
        }
        .noVipTips-box {
            max-width: 100%;
            width: 330px;
            height: 32px;
            padding: 0 16px;
            position: absolute;
            z-index: 1;
            top: 16px;
            left: 0;
            right: 0;
            margin: auto;
            background: linear-gradient(267.65deg, #ffdba6 9.41%, #fff5c6 90.77%);
            border-radius: 32px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            &:hover {
                background: linear-gradient(267.65deg, #ffcd83 9.41%, #ffeba6 90.77%);
            }
            .vip-icon {
                margin-right: 8px;
                width: 16px;
                height: 16px;
            }
            span {
                display: inline-block;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 14px;
                line-height: 16px;
                color: #4b2603;
            }
        }
        .end-tip {
            z-index: 1;
            font-size: 14px;
            color: white;
            position: absolute;
            top: 54px;
            left: 50%;
            transform: translateX(-50%);
        }
        .slider-present-tool {
            z-index: 1;
            position: fixed;
            bottom: 52px;
            left: 50%;
            transform: translateX(-50%);
            background-color: #333333;
            border-radius: 4px;
            padding: 3px;
            height: 36px;
            width: 223px;
            display: flex;
            justify-content: space-around;
            .item-icon {
                width: 30px;
                height: 30px;
                border-radius: 4px;
                cursor: pointer;
                &:hover {
                    background-color: #666666;
                }
            }
        }
    }
    .slider-presented {
        display: block;
    }
</style>
<i18n>
{
  "zh": {
    "endTip": "放映结束，单击鼠标退出。",
    "nonvipTips": "非会员仅可免费播放5页，<b>开通VIP解锁限制</b>"
  },
  "en": {
    "endTip": "End of slide show, click to exit.",
    "nonvipTips": "With the Free version you can only play 5 slides. <b>Upgrade to Premium for unlimited access.</b>"
  },
  "fr": {
    "endTip": "Fin du diaporama, cliquer pour quitter.",
    "nonvipTips": "Avec la version gratuite, vous ne pouvez visualiser que cinq diapositives. <b>Passez à la version Premium pour un accès illimité.</b>"
  },
  "de": {
    "endTip": "Ende der Diashow, zum Beenden klicken.",
    "nonvipTips": "Mit der kostenlosen Version können Sie nur 5 Folien wiedergeben. <b>Führen Sie ein Upgrade auf Premium durch, um uneingeschränkten Zugriff zu genießen.</b>"
  },
  "jp": {
    "endTip": "プレゼンテーションが終了したら、クリックして閉じます。",
    "nonvipTips": "無料バージョンでは、スライドを 5 枚のみ再生できます。<b>無制限のアクセスを得るには、プレミアムにアップグレードしてください。</b>"
  },
  "es": {
    "endTip": "Fin de la presentación de diapositivas, haga clic para salir",
    "nonvipTips": "Con la versión Gratis solo puede reproducir 5 diapositivas. <b>Actualice a Premium para obtener acceso ilimitado.</b>"
  },
  "pt": {
    "endTip": "Fim da apresentação de slides, clicar para sair.",
    "nonvipTips": "Com a versão gratuita, você pode reproduzir apenas 5 slides. <b>Atualize para a versão Premium para ter acesso sem limites.</b>"
  },
  "it": {
    "endTip": "Lo slideshow è terminato. Clicca per uscire.",
    "nonvipTips": "Con la versione gratuita puoi riprodurre solo 5 diapositive. <b>Passa alla versione Premium per un accesso illimitato.</b>"
  },
  "tw": {
    "endTip": "放映結束，單擊鼠標退出。",
    "nonvipTips": "使用免費版本時，您只能播放 5 張投影片。<b>升級至 Premium 以享有無上限的存取權限。</b>"
  },
  "kr": {
    "endTip": "슬라이드 쇼가 끝나면 클릭하여 종료합니다.",
    "nonvipTips": "무료 버전에서는 5개의 슬라이드만 재생할 수 있습니다. <b>프리미엄으로 업그레이드하여 무제한 액세스를 이용하십시오.</b>"
  },
  "id": {
    "nonvipTips": "Dengan versi Gratis ini, Anda hanya dapat memutar 5 slide. <b>Tingkatkan ke Premium untuk akses tak terbatas.</b>"
  }
}
</i18n>
<template>
    <div
        class="slider-container"
        ref="rootEle"
        :class="{
            'slider-presented': isPresented,
            'grab-cursor': zoomFact > 1,
            'grabing-cursor': isDrag,
            'hide-cursor': !mouseActived,
        }"
    >
        <div class="noVipTips-box" v-if="!vip" @click.stop="toVip" id="vip-btn-slider">
            <VipIcon />
            <span :title="$t('nonvipTips').replace(/\<.[^\>]*\>/g, '')" v-html="$t('nonvipTips')"></span>
        </div>
        <div class="slider-present" ref="slidePresent">
            <canvas ref="canvas" id="sliderCanvas"></canvas>
            <canvas ref="animationCanvas" id="sliderAnimationCanvas"></canvas>
            <div class="echart-list" ref="echartList" v-if="showEchartList">
                <SlideEchartBox v-for="item in echartList" :chartInfo="item" :key="item ? item.itemId : ''" />
            </div>
        </div>
        <div v-if="isEndSlide" class="end-tip">
            {{ $t("endTip") }}
        </div>
        <div v-if="showTools" ref="presentTools" class="slider-present-tool">
            <iconSymbol @click.native.stop="toPrevious" class="item-icon" :name="'sliderToPrev'" />
            <iconSymbol @click.native.stop="toNext" class="item-icon" :name="'sliderToNext'" />
            <iconSymbol @click.native.stop.prevent="slideZoomUp(null)" class="item-icon" :name="'sliderZoomUp'" />
            <iconSymbol @click.native.stop.prevent="slideZoomDown(null)" class="item-icon" :name="'sliderZoomDown'" />
            <iconSymbol @click.native.stop="endSlider" class="item-icon" :name="'endSliderPresent'" />
        </div>
        <BuyFrame v-if="showBuyframe" @closeBuyFrame="closeBuyFrame" @click.native.stop type="slider" :showCallback="showCallback" />
        <BuyDiscount v-model="showBuyDiscount" type="slider" :showCallback="showCallback" />
        <BuyPackage v-model="showBuyPackage" type="slider" :showCallback="showCallback" />
    </div>
</template>

<script lang="ts">
    declare var EDView: any;
    declare var $edAuth: any;
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import BuyFrame from "@/public/components/buyFrame.vue";
    import BuyDiscount from "@/public/components/BuyDiscount.vue";
    import BuyPackage from "@/public/components/BuyPackage.vue";
    import SlideEchartBox from "@/app/components/thirdpart/SlideEchartBox.vue";
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            BuyFrame,
            BuyDiscount,
            BuyPackage,
            SlideEchartBox,
        },
    })
    export default class SliderContainer extends Vue {
        // 初始数据可以直接声明为实例的属性
        currenPresentIdx: number = 0; //当前页面/幻灯片 index
        isPageSlide: boolean = false; // 是否是页面整体播放。
        isEndSlide: boolean = false; //是否正在播放幻灯片。
        mouseActived: boolean = false; //鼠标是否激活状态
        showTools: boolean = false; //是否显示工具条
        hideTimeoutId: number = null; // 延时器id;

        zoomFact: number = 1;
        xOffset: number = 0;
        yOffset: number = 0;

        isDrag: boolean = false;

        preFull: boolean = false; //播放前是否处于全屏状态
        preFulled: boolean = false; // 播放中，并且播放前处于全屏状态。
        showBuyframe: boolean = false;
        showBuyDiscount: boolean = false;
        showBuyPackage: boolean = false;
        playedArr: Array<number> = [];
        browser: string = "";
        showEchartList = false;

        get echartList() {
            return this.$store.state.thirdpart.slideEchartList.filter((item) => item != null)[this.currenPresentIdx];
        }

        get isPresented() {
            return this.$store.state.ui.isSlidePresented;
        }
        set isPresented(v) {
            this.$store.commit("setStatus", {
                type: "isSlidePresented",
                data: v,
            });
        }
        get sliderNums() {
            return this.$store.state.ui.sliders.length;
        }
        get pageNums() {
            return this.$store.state.page.pages.length;
        }

        closeBuyFrame() {
            this.showBuyframe = false;
            //关闭弹窗时更新vip状态
            this.updateVipStatus();
        }
        showCallback(status) {
            if (status == 1) {
                this.showBuyDiscount = true;
            } else if (status == 2) {
                this.showBuyPackage = true;
            } else if (status == 3) {
                this.showBuyframe = true;
            }
        }
        get userInfo() {
            return this.$store.state.user.userInfo;
        }

        updateVipStatus() {
            if (this.isPlugin || this.isTeamsApp || this.$store.state.ui.openFileLoading || this.isInclowdz || this.isPrivate) return;
            const ts = this as any;
            const vipTrigger = this.$store.state.publicStore.upgradeTrigger;
            this.$store.commit("toPublicStatus", {
                type: "upgradeTrigger",
                data: "",
            });
            // 重新获取vip信息
            ts.$store
                .dispatch("updateVipStatus", {
                    user_id: ts.userInfo.user_id,
                    token: ts.userInfo.token,
                })
                .then(() => {
                    if (vipTrigger) {
                        this.sensors.track("upgradePlanSuccess", {
                            Catalogues: "payPath",
                            upgrade_trigger: vipTrigger,
                        });
                    }
                });
        }
        get isAd() {
            return this.$store.state.isAd;
        }

        get buyUrl() {
            let asd = {
                en: this.isAd ? "https://www.edrawmax.com/ad/pricing-new.html" : "https://www.edrawmax.com/pricing-new/online-pa.html",
                de: "https://www.edrawsoft.com/de/pricing-edrawmax.html",
                jp: "https://www.edrawsoft.com/jp/pricing-edrawmax.html",
                es: "https://www.edrawsoft.com/es/pricing-edrawmax.html",
                fr: "https://www.edrawsoft.com/fr/pricing-edrawmax.html",
                it: "https://www.edrawsoft.com/it/pricing-edrawmax.html",
                pt: "https://www.edrawsoft.com/pt/pricing-edrawmax.html",
                tw: "https://www.edrawsoft.com/tw/pricing-edrawmax.html",
                kr: "https://www.edrawsoft.com/kr/pricing-edrawmax.html",
            };
            let url = asd[this.lang] || "https://www.edrawmax.com/pricing-new/online-pa.html";
            return url;
        }

        toVip() {
            if (window.EDCONFIG.IS_SDK) return;
            if (this.internal) {
                if (!this.vip) {
                    this.showBuyframe = true;
                    this.$store.commit("toPublicStatus", {
                        type: "upgradeTrigger",
                        data: "presentationFloat",
                    });
                }
            } else {
                window.open(this.buyUrl);
            }
        }
        toEnd() {
            this.isEndSlide = true;
            let canvas = this.$refs.canvas as HTMLCanvasElement;
            canvas.width = 0;
            let animationCanvas = this.$refs.animationCanvas as HTMLCanvasElement;
            animationCanvas.width = 0;
            window["_view"].stopSliderAnimation();
        }
        toNext() {
            if (this.isPageSlide) {
                if (this.currenPresentIdx + 1 > this.pageNums && this.isEndSlide) {
                    this.endSlider();
                    return;
                } else if (this.currenPresentIdx + 1 === this.pageNums) {
                    this.currenPresentIdx++;
                    this.toEnd();
                    return;
                }
            } else {
                if (this.currenPresentIdx + 1 > this.sliderNums && this.isEndSlide) {
                    this.endSlider();
                    return;
                } else if (this.currenPresentIdx + 1 === this.sliderNums) {
                    this.currenPresentIdx++;
                    this.toEnd();
                    return;
                }
            }
            this.draw(this.currenPresentIdx + 1);
            this.currenPresentIdx = this.currenPresentIdx + 1;
        }
        toPrevious() {
            if (this.currenPresentIdx - 1 < 0) return;
            this.isEndSlide = false;
            this.draw(this.currenPresentIdx - 1);

            this.currenPresentIdx = this.currenPresentIdx - 1;
        }

        draw(index) {
            let canvas = this.$refs.canvas as HTMLCanvasElement;
            let echartWrapperEle = this.$refs.echartList as HTMLDivElement;
            let animationCanvas = this.$refs.animationCanvas as HTMLCanvasElement;

            if (this.isPageSlide) {
                window["_view"].updatePresentPage(index, canvas, echartWrapperEle, animationCanvas);
            } else {
                window["_view"].updatePresent(index, canvas, echartWrapperEle, animationCanvas);
            }
        }

        @Watch("currenPresentIdx")
        currenPresentIdxChange(val) {
            if (!this.playedArr.includes(val)) {
                this.playedArr.push(val);
                if (!this.vip && this.playedArr.length > 5) {
                    this.endSlider();
                    if (window.EDCONFIG.IS_SDK) {
                        return;
                    }
                    this.$checkAuth({ type: "playSlide", buyTrigger: "presentationPop" });
                    return;
                }
            }
        }
        toFullScreen(rootEle) {
            if (rootEle.requestFullscreen) {
                this.isPresented = true;
                return rootEle.requestFullscreen();
            } else if (rootEle.webkitRequestFullscreen) {
                this.isPresented = true;
                return rootEle.webkitRequestFullscreen();
            } else if (rootEle.mozRequestFullScreen) {
                return rootEle.mozRequestFullScreen();
            } else if (rootEle.msRequestFullscreen) {
                return rootEle.msRequestFullscreen();
            }
        }
        startSlider() {
            this.playedArr = [];
            this.$bus.$emit("exitFocus");
            setTimeout(() => {
                this.currenPresentIdxChange(this.currenPresentIdx);
                console.log("start");
                let rootEle = this.$refs.rootEle as HTMLElement;
                let canvas = this.$refs.canvas as HTMLCanvasElement;
                let pro = this.toFullScreen(rootEle);
                if (pro) {
                    pro.then((e) => {
                        this.isPresented = true;
                        this.showEchartList = true;
                    });
                } else {
                    this.isPresented = true;
                    this.showEchartList = true;
                }
                if (this.isWorkwx || this.isTeamsApp) {
                    window["_view"].updatePresent(
                        this.currenPresentIdx,
                        this.$refs.canvas as HTMLCanvasElement,
                        this.$refs.echartList,
                        this.$refs.animationCanvas
                    );
                }
            }, 100);
        }
        endSlider() {
            this.showEchartList = false;
            this.$store.commit("cleanSlideEChartState");
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if ((<any>document).webkitExitFullscreen) {
                (<any>document).webkitExitFullscreen();
            } else if ((<any>document).mozExitFullScreen) {
                (<any>document).mozExitFullScreen();
            } else if ((<any>document).msExitFullscreen) {
                (<any>document).msExitFullscreen();
            }
        }
        slideZoomUp(e: MouseEvent) {
            if (this.zoomFact === 2) return;
            let newZoom = this.zoomFact + 0.25;
            this.zoomFunc(e, newZoom);
        }
        slideZoomDown(e: MouseEvent) {
            if (this.zoomFact === 1) return;

            let newZoom = this.zoomFact - 0.25;
            this.zoomFunc(e, newZoom);
        }
        slideZoomReset(e: MouseEvent) {
            this.zoomFunc(e, 1);
        }
        zoomFunc(e, newZoom) {
            let availWidth = document.documentElement.clientWidth;
            let availHeight = document.documentElement.clientHeight;

            let canvas = <HTMLCanvasElement>this.$refs.canvas;
            let echartWrapperEle = this.$refs.echartList as HTMLDivElement;
            let animationCanvas = <HTMLCanvasElement>this.$refs.animationCanvas;

            let width = canvas.width / 2; // 初始宽度
            let height = canvas.height / 2;

            let visibleWidth = width * this.zoomFact; //实际宽度
            let visibleHeight = height * this.zoomFact;
            let left = availWidth > visibleWidth ? (availWidth - visibleWidth) / 2 : 0;
            let top = availHeight > visibleHeight ? (availHeight - visibleHeight) / 2 : 0;
            let originX = e ? e.pageX : availWidth / 2;
            let originY = e ? e.pageY : availHeight / 2;
            let mouseX = originX - left;
            let mouseY = originY - top;

            let xToCenter = (mouseX - (availWidth / 2 + this.xOffset)) / this.zoomFact;
            let yToCenter = (mouseY - (availHeight / 2 + this.yOffset)) / this.zoomFact;

            this.zoomFact = newZoom;
            if (width * newZoom > availWidth && height * newZoom > availHeight) {
                let xOffset = xToCenter * this.zoomFact;
                let yOffset = yToCenter * this.zoomFact;
                let visX = availWidth / 2 + xOffset;
                let visY = availHeight / 2 + yOffset;
                this.xOffset = originX - visX;
                this.yOffset = originY - visY;
                if ((width * this.zoomFact) / 2 - availWidth / 2 - this.xOffset < 0) {
                    this.xOffset = (width * this.zoomFact) / 2 - availWidth / 2;
                }
                if ((height * this.zoomFact) / 2 - availHeight / 2 - this.yOffset < 0) {
                    this.yOffset = (height * this.zoomFact) / 2 - availHeight / 2;
                }
                if ((width * this.zoomFact) / 2 - availWidth / 2 + this.xOffset < 0) {
                    this.xOffset = -((width * this.zoomFact) / 2 - availWidth / 2);
                }
                if ((height * this.zoomFact) / 2 - availHeight / 2 + this.yOffset < 0) {
                    this.yOffset = -((height * this.zoomFact) / 2 - availHeight / 2);
                }
            } else {
                this.xOffset = 0;
                this.yOffset = 0;
            }
            let transformStr = `scale(${this.zoomFact}) translate(${this.xOffset / this.zoomFact}px,${this.yOffset / this.zoomFact}px)`;
            canvas.style.transform = transformStr;
            echartWrapperEle.style.transform = transformStr;
            animationCanvas.style.transform = transformStr;
        }

        //生命周期
        mounted() {}

        getBrowser() {
            let userAgent = window.navigator.userAgent; //取得浏览器的userAgent字符串
            if (userAgent.indexOf("IE") != -1) {
                //字符串含有IE字段，表明是IE浏览器
                this.browser = "IE";
            } else if (userAgent.indexOf("Firefox") != -1) {
                //字符串含有Firefox字段，表明是火狐浏览器
                this.browser = "Firefox";
            } else if (userAgent.indexOf("OPR") != -1) {
                //Opera
                this.browser = "Opera";
            } else if (
                userAgent.indexOf("Chrome") != -1 &&
                userAgent.indexOf("360SE") == -1 &&
                userAgent.indexOf("Metasr") == -1 &&
                userAgent.indexOf("QQBrower") == -1
            ) {
                //Chrome
                this.browser = "Chrome";
            } else if (userAgent.indexOf("Safari") != -1) {
                //Safari
                this.browser = "Safari";
            } else if (userAgent.indexOf("Trident") != -1) {
                //IE内核
                this.browser = "IE 11";
            }
        }

        created() {
            let ts = this;
            this.getBrowser();
            let resizeEvent = (e) => {
                let fullEle = document.fullscreenElement || (<any>document).webkitFullscreenElement;
                if (fullEle && fullEle !== this.$refs.rootEle) {
                    console.log("normalFull");
                    ts.preFull = true;
                } else if (ts.preFull && !fullEle) {
                    ts.preFull = false;
                } else if (ts.isPresented && fullEle) {
                    ts.mouseActived = false;
                    ts.showTools = false;
                    ts.draw(ts.currenPresentIdx);
                }
            };

            window.addEventListener("resize", resizeEvent);

            let processEvent = (e) => {
                let fullEle = document.fullscreenElement || (<any>document).webkitFullscreenElement;
                let preFull = false;
                if (this.browser == "Safari") {
                    // safari 浏览器全屏后是单独开一个窗口去显示全屏的内容，因此在 fullscreenChange 之后不会触发 resize 事件，
                    // 则不会 执行 window._view 的方法，表现为第一张 ppt 内容为空
                    if (fullEle && fullEle === this.$refs.rootEle) {
                        preFull = true;
                    }
                }

                if (ts.isPresented && (ts.preFull || preFull)) {
                    ts.preFull = false;
                    ts.preFulled = true;
                    ts.mouseActived = false;
                    ts.showTools = false;
                    ts.draw(ts.currenPresentIdx);
                    return;
                }
                if (ts.isPresented && fullEle == null) {
                    if (ts.preFulled) {
                        ts.preFull = true;
                    } else {
                        ts.preFulled = false;
                    }
                    ts.preFulled = false;

                    ts.isPresented = false;
                    ts.isPageSlide = false;
                    ts.isEndSlide = false;

                    ts.zoomFact = 1;
                    ts.xOffset = 0;
                    ts.yOffset = 0;
                    ts.isDrag = false;
                    (<any>ts.$refs.canvas).width = 0;
                    (<any>ts.$refs.canvas).style.width = null;
                    (<any>ts.$refs.canvas).style.height = null;
                    (<any>ts.$refs.canvas).style.transform = null;
                    if (this.hideTimeoutId) {
                        clearTimeout(this.hideTimeoutId);
                        this.hideTimeoutId = null;
                    }
                }
            };
            if (document.onfullscreenchange !== undefined) {
                document.addEventListener("fullscreenchange", processEvent);
            } else {
                document.addEventListener("webkitfullscreenchange", processEvent);
            }

            let zoomFunc = (e: MouseEvent) => {
                // 禁止Ctrl 滚轮缩放事件，WheelDelta +/-120 表示上下滚动，火狐是-/+ 3。
                let target = <Node>e.target;
                if (!this.isPresented) return;

                console.log(123);

                let ctrlkey = EDView.osInfo.platform === "Mac" ? e.metaKey : e.ctrlKey;
                if (ctrlkey) {
                    if ((<any>this.$refs.rootEle).contains(target)) {
                        if (e["wheelDelta"]) {
                            //IE/Opera/Chrome
                            if (e["wheelDelta"] > 0) {
                                this.slideZoomUp(e);
                            } else {
                                this.slideZoomDown(e);
                            }
                            e.preventDefault();
                        } else if (e.detail) {
                            //Firefox
                            if (e.detail < 0) {
                                this.slideZoomUp(e);
                            } else {
                                this.slideZoomDown(e);
                            }
                            e.preventDefault();
                        }
                    }
                }
            };
            let recXEvent = () => {
                let availWidth = document.documentElement.clientWidth;
                let availHeight = document.documentElement.clientHeight;
                let canvas = <HTMLCanvasElement>this.$refs.canvas;
                let echartWrapperEle = this.$refs.echartList as HTMLDivElement;
                let animationCanvas = this.$refs.animationCanvas as HTMLCanvasElement;
                let width = canvas.width / 2; // 初始宽度
                let height = canvas.height / 2;
                if (width * this.zoomFact < availWidth) {
                    this.xOffset = 0;
                } else {
                    if ((width * this.zoomFact) / 2 - availWidth / 2 - this.xOffset < 0) {
                        console.log("left");
                        this.xOffset = (width * this.zoomFact) / 2 - availWidth / 2;
                    }
                    if ((width * this.zoomFact) / 2 - availWidth / 2 + this.xOffset < 0) {
                        console.log("right");
                        this.xOffset = -((width * this.zoomFact) / 2 - availWidth / 2);
                    }
                }
                if (height * this.zoomFact < availHeight) {
                    this.yOffset = 0;
                } else {
                    if ((height * this.zoomFact) / 2 - availHeight / 2 - this.yOffset < 0) {
                        this.yOffset = (height * this.zoomFact) / 2 - availHeight / 2;
                    }
                    if ((height * this.zoomFact) / 2 - availHeight / 2 + this.yOffset < 0) {
                        this.yOffset = -((height * this.zoomFact) / 2 - availHeight / 2);
                    }
                }
                let transformStr = `scale(${this.zoomFact}) translate(${this.xOffset / this.zoomFact}px,${this.yOffset / this.zoomFact}px)`;
                canvas.style.transform = transformStr;
                echartWrapperEle.style.transform = transformStr;
                animationCanvas.style.transform = transformStr;
            };
            window.addEventListener("DOMMouseScroll", zoomFunc, { passive: false }); //firefox;
            window.addEventListener("wheel", zoomFunc, { passive: false }); //IE/Opera/Chrome/Safari
            document.addEventListener("mousemove", (e) => {
                let fullEle = document.fullscreenElement || (<any>document).webkitFullscreenElement;
                if (ts.isPresented && fullEle != null) {
                    if (ts.isDrag) {
                        let canvas = <HTMLCanvasElement>this.$refs.canvas;
                        let xOffset = e.movementX;
                        let yOffset = e.movementY;
                        this.xOffset += xOffset;
                        this.yOffset += yOffset;
                        recXEvent();
                    } else {
                        ts.mouseActived = true;
                        if (ts.hideTimeoutId) {
                            clearTimeout(ts.hideTimeoutId);
                        }
                        ts.hideTimeoutId = setTimeout(() => {
                            ts.mouseActived = false;
                            clearTimeout(ts.hideTimeoutId);
                            ts.hideTimeoutId = null;
                        }, 2333);
                        if (window.innerHeight - e.pageY < 150) {
                            ts.showTools = true;
                        } else {
                            ts.showTools = false;
                        }
                    }
                }
            });
            document.addEventListener("keydown", (e) => {
                let fullEle = document.fullscreenElement || (<any>document).webkitFullscreenElement;
                if (ts.isPresented && fullEle != null) {
                    if (e.keyCode === 39 || e.keyCode === 40 || e.keyCode === 32 || e.keyCode === 78 || e.keyCode === 34) {
                        ts.toNext();
                    } else if (e.keyCode === 37 || e.keyCode === 38 || e.keyCode === 33 || e.keyCode === 80) {
                        ts.toPrevious();
                    }
                }
            });
            document.addEventListener("mousedown", (e) => {
                let fullEle = document.fullscreenElement || (<any>document).webkitFullscreenElement;
                if (ts.isPresented && fullEle != null && fullEle === this.$refs.rootEle && !ts.preFull) {
                    if (this.zoomFact > 1) {
                        if ((e.button === 0 || e.button === 1) && <any>ts.$refs.slidePresent && (<any>ts.$refs.slidePresent).contains(e.target)) {
                            this.isDrag = true;
                        } else if (e.button === 2) {
                            this.slideZoomReset(e);
                        }
                    }
                }
            });
            document.addEventListener("mouseup", (e) => {
                let fullEle = document.fullscreenElement || (<any>document).webkitFullscreenElement;
                if (ts.isPresented && fullEle != null && fullEle === this.$refs.rootEle && !ts.preFull) {
                    if (ts.isDrag) {
                        ts.isDrag = false;
                    }
                }
            });
            document.addEventListener("click", (e) => {
                let fullEle = document.fullscreenElement || (<any>document).webkitFullscreenElement;
                if (ts.isPresented && fullEle != null && fullEle === this.$refs.rootEle && !ts.preFull) {
                    if (ts.isDrag) {
                        ts.isDrag = false;
                    }
                    if (ts.zoomFact === 1 && !(<any>ts.$refs.presentTools && (<any>ts.$refs.presentTools).contains(e.target))) {
                        ts.toNext();
                    }
                }

                // 移除帮助提示
                // window['_view'].UI.hideHelpTips()
            });
            this.$bus.$on("startSliderPre", (index) => {
                if (!this.sliderNums) return;
                this.currenPresentIdx = index;
                this.startSlider();
            });
            this.$bus.$on("startPageSlides", (index) => {
                this.showBuyframe = false;
                this.isPageSlide = true;
                this.currenPresentIdx = index;
                this.startSlider();
            });

            ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "msfullscreenchange"].forEach((eventName) => {
                document.addEventListener(eventName, () => {
                    let fullEle = document.fullscreenElement || (<any>document).webkitFullscreenElement;
                    if (!fullEle) {
                        this.showEchartList = false;
                        this.$store.commit("cleanSlideEChartState");
                    }
                });
            });
        }
    }
</script>
